import { Subscription } from 'rxjs';
import { IOverlayParams, IOverlayUpdateParams, EOverlayUpdateMode } from './../../../../classes/def/views/overlay';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IViewSpecs, ViewSpecs, INavParams } from 'src/app/classes/def/nav-params/general';
import { ModalController } from '@ionic/angular';
import { ParamHandler } from 'src/app/classes/general/params';
import { ResourceManager } from 'src/app/classes/general/resource-manager';
import { EAlertButtonCodes } from 'src/app/classes/def/app/ui';


@Component({
  selector: 'modal-reward-popup',
  templateUrl: './reward-popup.component.html',
  styleUrls: ['./reward-popup.component.scss'],
})
export class RewardPopupViewComponent implements OnInit, OnDestroy {
  wrapperClass: string = "";
  innerClass: string = "";
  vs: IViewSpecs = ViewSpecs.getDefault();
  hasVideo: boolean = false;
  params: IOverlayParams = null;
  loaded: boolean = false;

  timeoutDispose;

  np: INavParams = null;
  extHandleSub: Subscription;

  mode = {
    continuous: false,
    timeout: false
  };

  headingText: string = "";
  descriptionText: string = "";
  longHeading: boolean = false;
  small: boolean = false;
  
  constructor(
    public modalCtrl: ModalController
  ) {

  }

  setTimeoutDispose(timeout: number) {
    this.timeoutDispose = setTimeout(() => {
      this.ok();
    }, timeout);
  }

  ngOnDestroy() {
    ResourceManager.clearTimeout(this.timeoutDispose);
    ResourceManager.clearSub(this.extHandleSub);
  }

  ngOnInit() {
    console.log("opening reward popup modal");
    let hasParams: boolean = ParamHandler.checkParams(this.np);
    if (hasParams) {
      let np: INavParams = ParamHandler.getParams(this.np);
      let params: IOverlayParams = np.params;
      this.params = params;
      if (np.view) {
        this.vs = np.view;
        this.small = this.vs.small;
      }
      console.log(this.params);
      this.wrapperClass = "padding-s";
      this.innerClass = "center-items";
      this.updateContent();
      this.loaded = true;
      if (this.params.extHandleObservable) {
        this.extHandleSub = this.params.extHandleObservable.subscribe((data: IOverlayUpdateParams) => {
          console.log("ext handle received: ", data);
          if (data != null) {
            switch (data.mode) {
              case EOverlayUpdateMode.updateContent:
                if (this.checkUpdateContentAvailable(data.params)) {
                  this.params = data.params;
                  this.updateContent();
                }
                break;
            }
          }
        }, (err: Error) => {
          console.error(err);
        });
      }
    }
  }

  updateContentDisp() {
    this.headingText = this.params.heading;
    this.descriptionText = this.params.description;
    if ((this.headingText != null) && (this.headingText.length > 10)) {
      this.longHeading = true;
    }
  }

  checkUpdateContentAvailable(newParams: IOverlayParams) {
    if (!newParams) {
      return false;
    }
    // if (this.params.continuous !== newParams.continuous) {
    //   return false;
    // }
    return true;
  }

  updateContent() {
    if (this.params.continuous) {
      this.mode.continuous = true;
      this.updateContentDisp();
    } else {
      this.updateContentDisp();
      if (this.params.timeout) {
        this.mode.timeout = true;
        this.setTimeoutDispose(this.params.timeout + 500);
      }
    }
  }


  dismiss(value: number) {
    if (value == null) {
      value = EAlertButtonCodes.cancel;
    }
    setTimeout(() => {
      this.modalCtrl.dismiss(value).then(() => {
      }).catch((err: Error) => {
        console.error(err);
      });
    }, 1);
  }

  ok() {
    this.dismiss(EAlertButtonCodes.ok);
  }

  cancel() {
    this.dismiss(EAlertButtonCodes.cancel);
  }
}
